import { render, staticRenderFns } from "./SpcCarriers.vue?vue&type=template&id=f9d4e5b6&scoped=true"
import script from "./SpcCarriers.vue?vue&type=script&lang=js"
export * from "./SpcCarriers.vue?vue&type=script&lang=js"
import style0 from "./SpcCarriers.vue?vue&type=style&index=0&id=f9d4e5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d4e5b6",
  null
  
)

export default component.exports